var youbora = require('youboralib')
require('./adapter')
if ($pdk.controller.plugInLoaded) {
  require('./register-plugin')
}
module.exports = youbora
